/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Video_Export_Status_ExportingInputs */



/**
* | output |
* | --- |
* | "Exporting: {timecode} done" |
*
* @param {Video_Export_Status_ExportingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_status_exporting = /** @type {((inputs: Video_Export_Status_ExportingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Status_ExportingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Exportation : ${i?.timecode} terminee`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Exportieren: ${i?.timecode} abgeschlossen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esportazione: ${i?.timecode} completata`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Экспорт: ${i?.timecode} завершен`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Exportando: ${i?.timecode} hecho`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导出完成：${i?.timecode}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`エクスポート中: ${i?.timecode} 完了`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`निर्यात हो रहा है: ${i?.timecode} पूरा हुआ`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Exportando: ${i?.timecode} concluído`)
	return /** @type {LocalizedString} */ (`Exporting: ${i?.timecode} done`)
});